





































import { Component, Vue, Ref } from 'vue-property-decorator'
import { getUseReport } from '@/api/evaluation'
import { fitToken } from '@/api/config'
  @Component({})
export default class extends Vue {
    private sortMap:any = {
      'descending': 1,
      'ascending': -1,
      null: 0
    }
    private searchParams:any = {
      // classroomId: '',
      // name: ''
    }
    private resultId: any = ''
    private mode: any = ''
    private token: any = ''
    get table() {
      return this.$refs.table as any
    }
    created() {
      if (!this.$route.query.searchParams) return
      let params = JSON.parse(this.$route.query.searchParams as string)
      this.searchParams = {
        ...params
      }
    }
    onSortChange(data:{column:any, prop:string, order: null|string}) {
      for (let key in this.searchParams) {
        if (key.indexOf('sort_') > -1) {
          this.searchParams[key] = 0
        }
      }
      let sortKey = 'sort_' + data.prop
      let sortVal = 0
      switch (data.order) {
        case 'descending':
          sortVal = -1
          break
        case 'ascending':
          sortVal = 1
          break
        case null:
          sortVal = 0
          break
      }
      this.searchParams[sortKey] = sortVal
      this.search()
    }
    private view(row: any) {
      getUseReport({ evaluationRecordId: row.evaluationRecordId }).then(res => {
        fitToken({}).then((res: any) => {
          this.resultId = row.dataId
          process.env.VUE_APP_DOMAIN_ENV === 'production'
            ? (this.mode = 'prod')
            : (this.mode = 'test')
          this.token = res.data.value
          this.$nextTick(() => {
            (this.$refs.scaleResult as any).show()
          })
        })
      })
    }
    search() {
      this.table.search()
    }
}
